<template>
    <div class="container-fluid mt--7">
        <!-- START DRAWER -->
        <a-drawer title="" width="550" placement="right" @close="onClose" :visible="drawerVisible">
            <div v-if="formType == 't'">
                <h6 class="heading-small text-muted mb-4">RTE Template</h6>  
                <base-input label="Name">
                    <a-input type="text" v-model="rteTemplate.name"/>
                </base-input>
                <base-input label="Code">
                    <a-input type="text" v-model="rteTemplate.code"/>
                </base-input>
                <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                    <button class="btn btn-success" @click.prevent="saveTemplate">Save</button>
                    <button class="btn" @click.prevent="onClose">Cancel</button>
                </div>
            </div>
            <div v-if="formType == 'c'">
                <h6 class="heading-small text-muted mb-4">RTE Category</h6>  

                <base-input label="RTE Template">
                    <a-input type="text" v-model="rteTemplate.name" disabled/>
                </base-input>

                <base-input label="Name">
                    <a-input type="text" v-model="rteCategory.name"/>
                </base-input>
                <base-input label="Code">
                    <a-input type="text" v-model="rteCategory.code"/>
                </base-input>
                <base-input label="Sequence">
                    <a-input type="number" v-model="rteCategory.sequence_id"/>
                </base-input>
                <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                    <button class="btn btn-success" @click.prevent="saveCategory">Save</button>
                    <button class="btn" @click.prevent="onClose">Cancel</button>
                </div>
            </div>
            <div v-if="formType == 'p'">
                <h6 class="heading-small text-muted mb-4">RTE Product</h6>  

                <base-input label="RTE Category">
                    <a-input type="text" v-model="rteCategory.name" disabled/>
                </base-input>

                <base-input label="Barcode Search" v-if="formMode == 'a'">
                    <a-input type="text" v-model="barcodeSearch" @keyup.enter="searchProduct"/>
                    <small><span class="fa fa-info-circle"/> Search the barcode of the product you wish to add on the selected RTE category</small>
                </base-input>

                <base-input label="Barcode" v-else>
                    <a-input type="text" v-model="rteProduct.barcode" @keyup.enter="searchProduct" disabled/>
                </base-input>
                <hr class="my-3">
                
                <div v-if="!_.isEmpty(rteProduct)" class="row">
                    <div class="col-md-4">
                        <a-upload disabled listType="picture-card" :fileList="fileList" >
                            <div v-if="fileList.length < 1" > +
                                <div class="ant-upload-text">No Image</div>
                            </div>
                        </a-upload>
                    </div>

                    <div class="col-md-8" v-if="formMode == 'a'">
                        <base-input label="Name">
                            <a-input type="text" v-model="rteProduct.name"/>
                        </base-input>
                        <base-input label="Stock No">
                            <a-input type="text" v-model="rteProduct.stock_no" disabled/>
                        </base-input>
                        <base-input label="Sequence No">
                            <a-input type="number" v-model="rteProduct.sequence_no"/>
                        </base-input>
                        <base-input label="Start Date">
                            <a-date-picker v-model="rteProduct.start_date" format="MM-DD-YYYY" placeholder="Start Date" style="width:100%"/>
                        </base-input>
                    </div>
                    <div class="col-md-8" v-else>
                        <base-input label="Name">
                            <a-input type="text" v-model="rteProduct.name"/>
                        </base-input>
                        <base-input label="Stock No">
                            <a-input type="text" v-model="rteProduct.ref_code" disabled/>
                        </base-input>
                        <base-input label="Sequence No">
                            <a-input type="number" v-model="rteProduct.sequence_no"/>
                        </base-input>
                        <base-input label="Start Date">
                            <a-date-picker v-model="rteProduct.start_date" format="MM-DD-YYYY" placeholder="Start Date" style="width:100%"/>
                        </base-input>
                    </div>

                    <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                        <button class="btn btn-success" @click.prevent="saveProduct">Save</button>
                        <button class="btn" @click.prevent="onClose">Cancel</button>
                    </div>

                </div>
            </div>
        </a-drawer>
        <!-- END DRAWER -->

        <div class="card mb-3">
          <div class="card shadow" style="min-height: 100%">
            <div class="card-header border-0">
              <div class="row align-items-center">
                
                <!-- START OF TEMPLATES -->
                <div class="col-md-4 col-sm-4" style="padding:0px; border-right: 1px #E9ECEF solid; height: 600px;">
                  <ul class="list-group list-group-flush" style="padding-left: 15px;">
                      <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                          <div class="row">
                                <div class="col-md-8">RTE TEMPLATES</div>
                                <div class="col-md-4 float-right">
                                    <base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer('t', 'a')"><span class="fa fa-plus"/> </base-button>
                                </div>
                              <!-- <div v-if="accessRights.includes('A')" class="col-md-4 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer('addCategory', 'division', null)"><span class="fa fa-plus"/> </base-button></div> -->
                          </div>
                      </li>
                      <div style="height: 545px; overflow-y: scroll;">
                        <!-- <li class="list-group-item" style="font-size: 14px;"><span class="fa fa-lock"/> &nbsp; Sample</li> -->
                        <li class="list-group-item" style="font-size: 14px" v-for="rteTemplate in rteTemplates" :key="rteTemplate.id" :class="[{selected2: rteTemplateId == rteTemplate.id}]">
                           <div class="row" @click="selectTemplate(rteTemplate)">
                              <div class="col-md-8">
                                  <a-dropdown v-if="rteTemplateId == rteTemplate.id">
                                    <a class="ant-dropdown-link" href="#">
                                      <span class="fa fa-ellipsis-v"></span> 
                                    </a>
                                    <a-menu slot="overlay">
                                      <a-menu-item @click="showDrawer('t', 'e')"> Edit - {{rteTemplate.name}} </a-menu-item>
                                      <a-menu-item  key=2 > 
                                        <a-popconfirm title="You are about to delete this record?" okText="Delete" cancelText="Cancel" @confirm="deleteTemplate()">
                                          Delete - {{rteTemplate.name}}
                                        </a-popconfirm>
                                      </a-menu-item>
                                    </a-menu>
                                  </a-dropdown> &nbsp; 
                                  {{rteTemplate.name}}
                              </div>
                              <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div>
                           </div>
                        </li>
                      </div>
                  </ul>
                </div>
                <!-- END OF TEMPLATES -->

                <!-- START OF CATEGORIES -->
                <div class="col-md-4 col-sm-4" style="padding:0px; border-right: 1px #E9ECEF solid; height: 600px;">
                  <ul class="list-group list-group-flush">
                      <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                          <div class="row">
                                <div class="col-md-8">RTE CATEGORIES</div>
                                <div class="col-md-4 float-right">
                                    <base-button :disabled="rteTemplateId == null" class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer('c', 'a')"><span class="fa fa-plus"/> </base-button>
                                </div>
                              <!-- <div v-if="accessRights.includes('A')" class="col-md-4 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer('addCategory', 'division', null)"><span class="fa fa-plus"/> </base-button></div> -->
                          </div>
                      </li>
                      <div v-if="rteCategories.length > 0" style="height: 545px; overflow-y: scroll;">
                        <!-- <li class="list-group-item" style="font-size: 14px;"><span class="fa fa-lock"/> &nbsp; Sample</li> -->
                        <li class="list-group-item" style="font-size: 14px" v-for="rteCateg in rteCategories" :key="rteCateg.id" :class="[{selected2: rteCategoryId == rteCateg.id}]">
                           <div class="row" @click="selectCategory(rteCateg)">
                              <div class="col-md-8">
                                  <a-dropdown v-if="rteCategoryId == rteCateg.id">
                                    <a class="ant-dropdown-link" href="#">
                                      <span class="fa fa-ellipsis-v"></span> 
                                    </a>
                                    <a-menu slot="overlay">
                                      <a-menu-item @click="showDrawer('c', 'e')"> Edit - {{rteCateg.name}} </a-menu-item>
                                      <a-menu-item  key=2 > 
                                        <a-popconfirm title="You are about to delete this record?" okText="Delete" cancelText="Cancel" @confirm="deleteCategory()">
                                          Delete - {{rteCateg.name}}
                                        </a-popconfirm>
                                      </a-menu-item>
                                    </a-menu>
                                  </a-dropdown> &nbsp; 
                                  {{rteCateg.name}}
                              </div>
                              <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div>
                           </div>
                        </li>
                      </div>
                      <div v-else style="height: 545px; overflow-y: scroll;">
                            <a-empty class='mt-5' :image-style="{height: '50px',}" >
                                <span slot="description"> No categories to display. Please select a template.</span>
                            </a-empty>
                      </div>
                  </ul>
                </div>
                <!-- END OF CATEGORIES -->

                <!-- START OF PRODUCTS -->
                <div class="col-md-4 col-sm-4" style="padding:0px; height: 600px;">
                  <ul class="list-group list-group-flush">
                      <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                          <div class="row">
                                <div class="col-md-8">RTE PRODUCTS</div>
                                <div class="col-md-4 float-right">
                                  <base-button :disabled="rteCategoryId == null" class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer('p', 'a')"><span class="fa fa-plus"/> </base-button>
                                </div>
                              <!-- <div v-if="accessRights.includes('A')" class="col-md-4 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer('addCategory', 'division', null)"><span class="fa fa-plus"/> </base-button></div> -->
                          </div>
                      </li>
                      <div v-if="rteProducts.length > 0" style="height: 545px; overflow-y: scroll;">
                        <!-- <li class="list-group-item" style="font-size: 14px;"><span class="fa fa-lock"/> &nbsp; Sample</li> -->
                        <li class="list-group-item" style="font-size: 14px" v-for="rteProduct in rteProducts" :key="rteProduct.id" :class="[{selected2: productId == rteProduct.id}]">
                           <div class="row" @click.prevent="selectProduct(rteProduct)">
                              <div class="col-md-8">
                                  <a-dropdown v-if="productId == rteProduct.id">
                                    <a class="ant-dropdown-link" href="#">
                                      <span class="fa fa-ellipsis-v"></span> 
                                    </a>
                                    <a-menu slot="overlay">
                                      <a-menu-item @click="showDrawer('p', 'e')"> Edit - {{rteProduct.name}} </a-menu-item>
                                      <a-menu-item  key=2 > 
                                        <a-popconfirm title="You are about to delete this record?" okText="Delete" cancelText="Cancel" @confirm="deleteProduct">
                                          Delete - {{rteProduct.name}}
                                        </a-popconfirm>
                                      </a-menu-item>
                                    </a-menu>
                                  </a-dropdown> &nbsp; 
                                  {{rteProduct.name}}
                              </div>
                              <!-- <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div> -->
                           </div>
                        </li>
                      </div>
                      <div v-else style="height: 545px; overflow-y: scroll;">
                            <a-empty class='mt-5' :image-style="{height: '50px',}" >
                                <span slot="description"> No products to display. </span>
                            </a-empty>
                      </div>
                  </ul>
                </div>
                <!-- END OF PRODUCTS -->

              </div>
            </div>  
          </div>
        </div>
      </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import HTTPRequest from '../../controllers/httpRequest.js'
    export default {
        data: function () {
            return {
                rteCategories: [],
                rteCategoryId: null,
                rteCategory: {},


                rteProducts: [], 
                productId: null, 
                rteProduct: {},
                barcodeSearch: null, 

                rteTemplates: [],
                rteTemplateId: null,
                rteTemplate: {},

                formType: "c",
                formMode: "a",
                drawerVisible: false,
                
                fileList: []

            }
        },
        mounted: async function(){
            this.getRteTemplates()
        },
        computed: {
            ...mapState(['endPoint', 'publicUrl'])
        },
        methods:{
            async getRteTemplates(){
                var options = await HTTPRequest.getRequest(this.endPoint + 'rte_templates', null);
                this.rteTemplates = options
            },
            async getRteCategories(){
                var options = await HTTPRequest.getRequest(this.endPoint + 'rte_categories', null);
                this.rteCategories = options
            },
            async selectCategory(selectedCateg){
                this.rteCategory = Object.assign({}, selectedCateg)
                this.rteCategoryId = selectedCateg.id;
                this.rteProduct = {}
                this.productId = null
                var options = await HTTPRequest.getRequest(this.endPoint + 'rte_products?rte_category_id=' + this.rteCategoryId , null);
                this.rteProducts = options
            },
            async selectProduct(selectedProduct){
                this.rteProduct = Object.assign({}, selectedProduct)
                this.productId = selectedProduct.id;
                 if(!_.isEmpty(this.rteProduct.filename)){
                        this.fileList = [{
                            uid: this.rteProduct.id,
                            name: this.rteProduct.filename,
                            status: 'done',
                            url: this.publicUrl + 'product_images/' + this.rteProduct.filename,
                        }]
                }
            },           
            async selectTemplate(selectedTemplate){
                this.rteTemplate = Object.assign({}, selectedTemplate)
                this.rteTemplateId = selectedTemplate.id;
                this.rteCategory = {}
                this.rteCategoryId = null
                this.rteProduct = {}
                this.productId = null
                var options = await HTTPRequest.getRequest(this.endPoint + 'rte_categories?rte_template_id=' + this.rteTemplateId , null);
                this.rteCategories = options
                this.rteProducts = []
            },    
            async saveTemplate(){
                var templateData = { rte_template: { name: this.rteTemplate.name, code: this.rteTemplate.code} }
                if(this.formMode == 'a'){
                    var options = await HTTPRequest.postRequest(this.endPoint + 'rte_templates', null, templateData);
                }else{
                    var options = await HTTPRequest.putRequest(this.endPoint + 'rte_templates/' + this.rteTemplateId , null, templateData);
                }
                if(options.error == undefined){
                    this.$message['success'](
                        "RTE Template operation was succesful"
                    );
                    this.onClose()
                    this.getRteTemplates()
                }else{
                    this.$message['error'](
                        "RTE Template operation failed - " + options.error
                    );
                }
                
            },
            async saveCategory(){
                var categoryData = { rte_category: { name: this.rteCategory.name, code: this.rteCategory.code, sequence_id: this.rteCategory.sequence_id, rte_template_id: this.rteTemplateId} }
                if(this.formMode == 'a'){
                    var options = await HTTPRequest.postRequest(this.endPoint + 'rte_categories', null, categoryData);
                }else{
                    var options = await HTTPRequest.putRequest(this.endPoint + 'rte_categories/' + this.rteCategoryId , null, categoryData);
                }
                if(options.error == undefined){
                    this.$message['success'](
                        "RTE Category operation was succesful"
                    );
                    this.onClose()
                    this.getRteCategories()
                    this.selectTemplate(this.rteTemplate)
                } else {
                    this.$message['error'](
                        "RTE Category operation failed - " + options.error
                    );

                }
            },
            async saveProduct(){
                if(this.formMode == 'a'){
                    var productData = { rte_product: { name: this.rteProduct.name, ref_code: this.rteProduct.stock_no, 
                                                   sequence_no: this.rteProduct.sequence_no, rte_category_id: this.rteCategoryId,
                                                   status: "A", filename: this.rteProduct.filename, start_date: this.rteProduct.start_date,
                                                   product_id: this.rteProduct.id, barcode: this.barcodeSearch
                                                } 
                                  }
                    var options = await HTTPRequest.postRequest(this.endPoint + 'rte_products', null, productData);
                }else{
                    var productData = { rte_product: { name: this.rteProduct.name, ref_code: this.rteProduct.ref_code, 
                                                   sequence_no: this.rteProduct.sequence_no, 
                                                   filename: this.rteProduct.filename, start_date: this.rteProduct.start_date,
                                                   product_id: this.rteProduct.product_id, barcode: this.rteProduct.barcode
                                                } 
                                  }
                    var options = await HTTPRequest.putRequest(this.endPoint + 'rte_products/' + this.rteProduct.id , null, productData);
                    // var options = await HTTPRequest.putRequest(this.endPoint + 'rte_categories/' + this.rteCategoryId , null, categoryData);
                }
                if(options.error == undefined){
                    this.$message['success'](
                        "RTE Product operation was succesful"
                    );
                    this.onClose()
                    this.selectCategory(this.rteCategory)
                } else {
                     this.$message['error'](
                        "RTE Product operation failed - " + options.error
                    );
                }
            },
            async searchProduct(){
                var product = await HTTPRequest.getRequest(this.endPoint + 'products?barcode=' + this.barcodeSearch , null);
                if(product.data.length > 0){
                    this.rteProduct = product.data[0]
                    if(!_.isEmpty(this.rteProduct.filename)){
                        this.fileList = [{
                            uid: this.rteProduct.id,
                            name: this.rteProduct.filename,
                            status: 'done',
                            url: this.publicUrl + 'product_images/' + this.rteProduct.filename,
                        }]
                    }
                }else{
                    this.$message['error'](
                            "Product not found. Please search another barcode."
                    );
                    this.rteProduct = {}
                }
            },
            async deleteTemplate(){
                var templateData = { rte_template: { status: 'D'} }
                var options = await HTTPRequest.putRequest(this.endPoint + 'rte_templates/' + this.rteTemplateId , null, templateData);
                this.onClose();
                this.getRteTemplates();
            },
            async deleteCategory(){
                var categoryData = { rte_category: { status: 'D'} }
                var options = await HTTPRequest.putRequest(this.endPoint + 'rte_categories/' + this.rteCategoryId , null, categoryData);
                this.onClose();
                this.selectTemplate(this.rteTemplate);
            },
            async deleteProduct(){
                var productData = { rte_product: { status: 'D'} }
                var options = await HTTPRequest.putRequest(this.endPoint + 'rte_products/' + this.productId , null, productData);
                this.onClose();
                this.selectCategory(this.rteCategory);
            },
            showDrawer(type, mode){
                this.formType = type;
                this.formMode = mode
                if(mode == 'a' && type == 'c'){
                    this.rteCategory = {}
                    this.rteCategoryId = null
                    this.rteProduct = {}
                    this.productId = null
                }
                if(mode == 'a' && type == 'p'){
                    this.rteProduct = {}
                    this.productId = null
                }
                if(mode == 'a' && type == 't'){
                    this.rteTemplate = {}
                    this.rteTemplateId = null
                    this.rteCategory = {}
                    this.rteCategoryId = null
                    this.rteProduct = {}
                    this.productId = null
                }
                this.drawerVisible = true;
            },
            onClose(){
                this.drawerVisible = false;
            }
        }
    }
</script>

<style>
.selected2{
    background-color:  #EFF6FF;
    color: #2371CC;
}
</style>